var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpinner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 122,
    viewBox: "0 0 122 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_635_805)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61 122C94.6894 122 122 94.6894 122 61C122 27.3106 94.6894 0 61 0C27.3106 0 0 27.3106 0 61C0 94.6894 27.3106 122 61 122ZM60.9941 90.8222C77.4645 90.8222 90.8163 77.4703 90.8163 61C90.8163 44.5296 77.4645 31.1777 60.9941 31.1777C44.5237 31.1777 31.1719 44.5296 31.1719 61C31.1719 77.4703 44.5237 90.8222 60.9941 90.8222Z",
    fill: "#CDCDCD",
    fillOpacity: 0.53
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.797 89.5098C119.526 80.6628 122 70.7861 122 60.7546H90.8163V60.7565C90.8163 77.2269 77.4645 90.5787 60.9941 90.5787C44.5237 90.5787 31.1719 77.2269 31.1719 60.7565C31.1719 52.5193 34.5115 45.0622 39.9105 39.6651L17.8665 17.6211C10.7731 24.7144 5.53864 33.4477 2.62664 43.0472C-0.28535 52.6468 -0.784948 62.8164 1.1721 72.6551C3.12915 82.4939 7.48245 91.6981 13.8464 99.4526C20.2103 107.207 28.3884 113.272 37.6563 117.111C46.9242 120.95 56.9958 122.444 66.979 121.461C76.9623 120.478 86.5489 117.047 94.8898 111.474C103.231 105.901 110.068 98.3568 114.797 89.5098Z",
    fill: "#CBCBCB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_635_805"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 122,
    height: 122,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/spinner.86e343991947ffea10974f0f3f083fb2.svg";
export { ForwardRef as ReactComponent };